/**
 * Count unread SMS threads (one per client) from team inbox messages.
 * A thread is unread when its latest message is inbound and not in readBy for the user.
 */
export function countUnreadSmsThreads(messages, userEmail) {
  if (!userEmail || !Array.isArray(messages) || messages.length === 0) {
    return 0;
  }

  const latestByClient = {};
  messages.forEach((msg) => {
    const clientId = msg.clientId;
    if (!clientId) return;
    const existing = latestByClient[clientId];
    if (!existing || new Date(msg.createdAt) > new Date(existing.createdAt)) {
      latestByClient[clientId] = msg;
    }
  });

  return Object.values(latestByClient).filter(
    (latest) =>
      latest.direction === 'inbound' &&
      !(Array.isArray(latest.readBy) && latest.readBy.includes(userEmail))
  ).length;
}
